import { toast } from 'react-toastify';

export const createNotification = (type, message, time = 3500) => {
  const toastOptions = {
    position: 'top-right',
    autoClose: time,
    hideProgressBar: false,
    closeOnClick: true,
    pauseOnHover: true,
    draggable: true,
    toastId: message,
  };

  switch (type) {
    case 'info':
      toast.info(message, toastOptions);
      break;
    case 'success':
      toast.success(message, toastOptions);
      break;
    case 'warning':
      toast.warning(message, toastOptions);
      break;
    case 'error':
      toast.error(message, toastOptions);
      break;
    default:
      toast.error('Some error occurred, please check your internet connection or try again later!', toastOptions);
      break;
  }
};